var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGitSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 73 73",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "team-collaboration/version-control/git") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "team-collaboration/version-control/git",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "container",
    transform: "translate(2.000000, 2.000000)",
    fill: "#000000",
    fillRule: "nonzero",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "mask",
    x: -1,
    y: -1,
    width: 71,
    height: 71,
    rx: 14
  })), /*#__PURE__*/React.createElement("g", {
    id: "git-logo",
    transform: "translate(21.000000, 19.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.43875,26.0023125 L14.8751875,26.0023125 L14.8751875,12.7198125 C14.5418125,12.836625 14.1139375,12.9639375 13.5206875,13.1004375 C13.7215,13.6779375 13.8750625,14.22 13.8750625,14.724 C13.8750625,16.3370625 13.388125,17.7414375 12.4208125,18.937125 C11.4495625,20.1328125 10.1974375,20.8455 8.6618125,21.0699375 C7.6538125,21.2195625 7.1498125,21.7629375 7.1498125,22.696125 C7.1498125,23.021625 7.31125,23.34975 7.639375,23.677875 C8.0685625,24.1543125 8.694625,24.4588125 9.52675,24.580875 C13.1295625,25.1386875 14.9276875,26.6349375 14.9276875,29.0788125 C14.9276875,32.9848125 12.5940625,34.9365 7.933375,34.9365 C6.0210625,34.9365 4.43425,34.59525 3.2018125,33.918 C1.6399375,33.0609375 0.838,31.7116875 0.838,29.8741875 C0.838,27.75975 1.927375,26.308125 4.310875,25.5285 L4.310875,25.455 C3.449875,24.92475 3.066625,24.118875 3.066625,23.0360625 C3.066625,21.625125 3.449875,20.743125 4.310875,20.38875 L4.310875,20.312625 C3.449875,20.037 2.791,19.407 2.161,18.42525 C1.45225,17.3660625 1.103125,16.236 1.103125,15.025875 C1.103125,13.2106875 1.7475625,11.7013125 3.0338125,10.4911875 C4.2675625,9.3585 5.738875,8.7915 7.453,8.7915 C8.6854375,8.7915 9.7800625,9.0920625 10.8379375,9.697125 C12.0218125,9.697125 13.398625,9.4044375 14.8778125,8.82825 L14.8778125,8.0368125 L19.441375,8.0368125 L19.441375,26.0023125 L19.43875,26.0023125 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1171875,5.2018125 C18.59875,5.7556875 17.98975,6.032625 17.2849375,6.032625 C16.5525625,6.032625 15.9304375,5.7556875 15.4133125,5.2018125 C14.8975,4.6479375 14.6389375,3.9916875 14.6389375,3.237 C14.6389375,2.457375 14.894875,1.788 15.4133125,1.2354375 C15.9304375,0.68025 16.553875,0.404625 17.2849375,0.404625 C17.987125,0.404625 18.5974375,0.68025 19.1171875,1.2354375 C19.633,1.7893125 19.8941875,2.4586875 19.8941875,3.237 C19.8941875,3.9916875 19.633,4.6479375 19.1171875,5.2018125 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5070625,25.2620625 C29.6434375,25.77 28.48975,26.0206875 27.179875,26.0206875 C25.342375,26.0206875 24.103375,25.3644375 23.3985625,24.0519375 C22.8683125,23.0728125 22.601875,21.52275 22.601875,19.407 L22.601875,12.93375 L20.3509375,12.93375 L20.3509375,8.767875 L22.601875,8.767875 L22.601875,6.363375 L26.675875,6.363375 C26.696875,6.956625 26.7270625,8.21925 26.7401875,8.767875 L30.2314375,8.767875 L30.2314375,12.93375 L26.7454375,12.93375 L26.7454375,19.5973125 C26.7454375,21.283875 27.2914375,22.129125 28.403125,22.129125 C29.18275,22.129125 29.8219375,21.9178125 30.511,21.4873125 L30.511,25.263375 L30.5070625,25.263375 L30.5070625,25.2620625 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.602625,12.267 C6.017125,12.267 5.2230625,13.2001875 5.2230625,15.0639375 C5.2230625,16.8016875 6.017125,17.6705625 7.602625,17.6705625 C9.1395625,17.6705625 9.9060625,16.78725 9.9060625,15.025875 C9.9060625,14.2935 9.7301875,13.6648125 9.3784375,13.1371875 C8.94925,12.558375 8.358625,12.267 7.602625,12.267 Z",
    id: "Shape",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8083125,29.64975 C4.8083125,30.9556875 5.91475,31.6119375 8.1315625,31.6119375 C10.0714375,31.6119375 11.0400625,30.93075 11.0400625,29.571 C11.0400625,28.2860625 9.9835,27.6429375 7.8664375,27.6429375 C5.8268125,27.6455625 4.807,28.3123125 4.8083125,29.64975 Z",
    id: "Shape",
    fill: "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitSvgrepoCom);
export default __webpack_public_path__ + "static/media/git-svgrepo-com.379fdf1e5f52d6f8368a505a4c20185b.svg";
export { ForwardRef as ReactComponent };